import { Text } from '@/components/ui/text';
import { Pressable, View } from 'react-native';

interface DiningTypeSectionProps {
  value: 'dine_in' | 'takeout';
  onChange: (value: 'dine_in' | 'takeout') => void;
  disabled?: boolean;
}

const OPTIONS: { value: 'dine_in' | 'takeout'; label: string }[] = [
  { value: 'dine_in', label: 'Dine-In' },
  { value: 'takeout', label: 'Take-Out' },
];

export function DiningTypeSection({ value, onChange, disabled }: DiningTypeSectionProps) {
  return (
    <View className="py-2">
      <Text className="text-sm font-medium mb-2 text-muted-foreground">
        How did you get it?
      </Text>
      <View className="flex-row" style={{ gap: 8 }}>
        {OPTIONS.map((option) => {
          const isSelected = value === option.value;
          return (
            <Pressable
              key={option.value}
              onPress={() => onChange(option.value)}
              disabled={disabled}
              className={`px-4 py-2 rounded-full ${isSelected ? 'bg-primary' : 'bg-surface border border-border'}`}
              style={{ minHeight: 36, opacity: disabled ? 0.5 : 1 }}
              accessibilityRole="button"
              accessibilityState={{ selected: isSelected }}
              accessibilityLabel={option.label}
            >
              <Text
                className={`text-sm font-medium ${isSelected ? 'text-background' : 'text-foreground'}`}
              >
                {option.label}
              </Text>
            </Pressable>
          );
        })}
      </View>
    </View>
  );
}
